export default __webpack_public_path__ + "static/media/shoot1.65db21d9.wav";